/**
 * @flow
 * @relayHash a128b68246b8930f6a5630ff63ba4dc7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCityMutationVariables = {|
  id: string
|};
export type DeleteCityMutationResponse = {|
  +deleteCity: {|
    +id: string
  |}
|};
export type DeleteCityMutation = {|
  variables: DeleteCityMutationVariables,
  response: DeleteCityMutationResponse,
|};
*/


/*
mutation DeleteCityMutation(
  $id: String!
) {
  deleteCity(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CityModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCityMutation",
    "id": null,
    "text": "mutation DeleteCityMutation(\n  $id: String!\n) {\n  deleteCity(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '27321c68fbd72fe7ce09e0fe279f6151';
module.exports = node;
